import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom';
import _ from 'lodash';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange({target}) {
        this.setState({
            [target.name]: target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.props.auth.submitLogin({
            username: this.state.username,
            password: this.state.password,
        });
    }

    render() {
        const {auth} = this.props;

        const hasUsernameAndPassword = _.get(this.state, 'username.length') > 0 && _.get(this.state, 'password.length') > 0;
        const loginButtonEnabled = hasUsernameAndPassword && !auth.apiActionPending;

        return (
            <div className='login-form row justify-content-md-center'>
                {auth.currentUser && <Redirect to="/" />}

                <div className='col col-md-4'>
                    <h3>Log In</h3>
                    <p className='text-muted'>Enter your username and password</p>

                    {this.state.errorMessage &&
            <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>
                    }

                    {auth.errorMessage &&
            <div className="alert alert-danger" role="alert">{JSON.parse(auth.errorMessage).error_description}</div>
                    }

                    {_.get(this.props, 'location.state.flashMessage') &&
            <div className="alert alert-info" role="alert">{this.props.location.state.flashMessage}</div>
                    }

                    <form onSubmit={this.handleSubmit}>
                        <div className='form-group'>
                            <input className='form-control' type='email' name='username' placeholder='Enter Username' value={this.state.username} onChange={this.handleChange} />
                        </div>

                        <div className='form-group'>
                            <input className='form-control' type='password' name='password' placeholder='Enter Password' value={this.state.password} onChange={this.handleChange} />
                        </div>

                        <button className='btn btn-primary' type='submit' disabled={!loginButtonEnabled}>Log In</button>

                        <small className="form-text text-muted">
                            Forgot your password?
                            <Link className='ml-1' to='/forgot-password'>Click Here</Link>
                        </small>
                    </form>
                </div>
            </div>
        );
    }
}

export default Login;
